import { render } from "./SimpleFloorPlanEditor.vue?vue&type=template&id=3098533e&scoped=true"
import script from "./SimpleFloorPlanEditor.vue?vue&type=script&lang=js"
export * from "./SimpleFloorPlanEditor.vue?vue&type=script&lang=js"

import "./SimpleFloorPlanEditor.vue?vue&type=style&index=0&id=3098533e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3098533e"]])

export default __exports__